/**
 * Created by mohameds on 1/7/19.
 */
import React from 'react';
import myPic from '../../public/assets/images/agencyMonitor/value.png';

const CoreValue = ({pageData = {}, settings={}}) => (
    <React.Fragment>
        {pageData.occasion_text && 
            <div className="btn btn-lg bg-white font-32 text-blue position-relative body-size mt-3 ">
                <div className="p-1" style={{whiteSpace: 'pre-line'}}>
                    {pageData.occasion_text && pageData.occasion_text}
                </div>
            </div>
        }
        <div className="qoute-image"
            style={settings && settings.show_header ? {}: {height: '750px'}}
        >
            <img src={pageData.image ? pageData.image : myPic} 
                onError={(e) => {console.log(e.target)}}
                alt={pageData.occasion_text && pageData.occasion_text}
            />
        </div>
    </React.Fragment>
)

export default CoreValue


// WEBPACK FOOTER //
// ./src/components/agencyMonitor/CoreValue.js